/* Shared column template — must match .columnHeader in AllConnectionsList.module.css */
.row {
    display: grid;
    grid-template-columns: 2fr 1fr 1fr 120px 110px;
    align-items: center;
    gap: 16px;
    padding: 12px 16px;
    border: none;
    border-bottom: 1px solid var(--exo-color-border-secondary);
    text-align: left;
    width: 100%;
    cursor: pointer;
    background: none;
    color: var(--exo-color-font);
    transition: background 0.12s;
}

.row:last-child {
    border-bottom: none;
}

.row:hover {
    background: var(--exo-color-background-secondary);
}

.row:focus-visible {
    outline: 2px solid var(--exo-color-border-tertiary);
    outline-offset: -2px;
}

.connectionName {
    font-size: 14px;
    font-weight: 500;
    color: var(--exo-color-font-link);
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
}

.connectionCell {
    display: flex;
    align-items: center;
    gap: 8px;
    min-width: 0;
}

.secondaryText {
    font-size: 13px;
    color: var(--exo-color-font-secondary);
}
